import { render } from "./BaseButton.vue?vue&type=template&id=3c44b728&scoped=true&ts=true"
import script from "./BaseButton.vue?vue&type=script&lang=ts"
export * from "./BaseButton.vue?vue&type=script&lang=ts"

import "./BaseButton.vue?vue&type=style&index=0&id=3c44b728&scoped=true&lang=sass"

import exportComponent from "/Users/sotenck/GIT/kunden/iconomy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c44b728"]])

export default __exports__